export const BALE_THEME_URL = "https://www.bale-theme.my.id";
export const BALE_THEME_TEMPLATES_URL = `${BALE_THEME_URL}/templates`;
